import { render, staticRenderFns } from "./AgentPay.vue?vue&type=template&id=454554f1&"
import script from "./AgentPay.vue?vue&type=script&lang=js&"
export * from "./AgentPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports